// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { LoggedUserService } from './../../../../core/services/logged-user.service';
import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { QueueAlertAction, AlertType, RolesService, RoleGroup } from '@app/core';
import { State } from '@app/access-management/state';
import { GeneralDeleteModalComponent } from '@app/access-management/shared/delete-modal/delete-modal.component';
import { SelectedRows, DataTableAjaxComponent } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { RoleDetailsFacadeService } from '@app/access-management/state/role-details.facade';

@Component({
  selector: 'app-role-details-groups-tab',
  templateUrl: './role-details-groups-tab.component.html',
  styleUrls: ['./role-details-groups-tab.component.scss']
})
export class RoleDetailsGroupsTabComponent implements AfterViewInit {
  @Input() roleId!: string;

  @ViewChild('actionTemplate') actionTemplate: any;
  @ViewChild('dataTableAjax') dataTableAjax!: DataTableAjaxComponent;

  columns: any[] = [];

  _isUserAdmin = true;

  constructor(
    private modalService: NgbModal,
    private roleDetailFacade: RoleDetailsFacadeService,
    private loggedUserService: LoggedUserService,
    private store: Store<State>,
    private roleService: RolesService
  ) {}

  ngAfterViewInit() {
    this.loadRoleGroupsColumns();
  }

  loadRoleGroupsColumns() {
    this.columns = [
      {
        name: 'Group Name',
        prop: 'group_name',
        flexGrow: 2
      },
      {
        name: 'Description',
        prop: 'description',
        cellClass: 'ml-8',
        headerClass: 'ml-8',
        flexGrow: 2
      },
      {
        name: 'Actions',
        prop: 'id',
        cellTemplate: this.actionTemplate,
        flexGrow: 1
      }
    ];

    if (this._isUserAdmin) {
      const adminColumn = {
        name: 'Organization',
        prop: 'account_name',
        cellClass: 'ml-8',
        headerClass: 'ml-8',
        flexGrow: 2
      };

      this.columns.splice(1, 0, adminColumn);
    }
  }

  onSelectRow(rows: SelectedRows) {
    // @todo: implement ...
  }

  onEditClick(row: RoleGroup) {
    this.roleDetailFacade.goToRoleGroupScopes(this.roleId, row);
  }

  onRemoveRow(row: RoleGroup) {
    const modalRef = this.modalService.open(GeneralDeleteModalComponent, { centered: true, windowClass: 'no-border' });

    const componentInstance: GeneralDeleteModalComponent = modalRef.componentInstance;
    componentInstance.observable = this.roleService.removeRoleGroup(this.roleId, row.group_id);

    componentInstance.onSuccessRemove = () => {
      this.dataTableAjax.refreshTable();
      this.store.dispatch(new QueueAlertAction({ alertText: `Group delete succeeded.`, alertType: AlertType.SUCCESS }));
      componentInstance.close();
    };

    componentInstance.onFailRemove = () => {
      this.store.dispatch(new QueueAlertAction({ alertText: `Group delete failed.`, alertType: AlertType.ERROR }));
    };
  }

  trackColumns(idx: number) {
    return idx;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-details/role-details-groups-tab/role-details-groups-tab.component.ts